import React, { useEffect, useState } from 'react';
import { Aboutbody, Aboutperson, Details, Discription, Journey, Left, Marker, Title } from './Styled'
import aboutperson from '../../person2.svg';
import gsap from 'gsap';

import { markers } from './utils';
import { ScrollTrigger } from 'gsap/all';


const Index = () => {

    const [active, setActive] = useState(0)
    const [animationactive, setAnimationactive] = useState(0)
    useEffect(() => {

        gsap.registerPlugin(ScrollTrigger);
        gsap.to('.circle', {
            // width:"80%",

            scrollTrigger: {
                trigger: ".component1",
                start: "top 30%",
                end: "top 40% ",
                scrub: true,
                pin: true,
                // markers: true,
                onEnter: () => {
                    // this runs when the trigger hits the "start"
                    setAnimationactive(true);
                    console.log("Entered start! Condition set to true");
                },
            }
        })

    }, []);

    return (
        <Aboutbody className='component1' onClick={() => setActive(0)}  >
            <Left className="circle" activeId={active} onClick={(e) => e.stopPropagation()}>
                <Aboutperson src={aboutperson} />
                {!active && <Details>
                    <Title>About me</Title>
                    <Discription>Passionate technologist with expertise in Computer Science, AI, and ML. Skilled in software development, data analytics, and problem-solving, with strong academic achievements and industry experience. Dedicated to building impactful, innovative solutions from concept to production.
                    </Discription>
                </Details>}

                {animationactive && markers.map((m) => {
                    return (
                        <>
                            <Marker className={`marker marker${m.id}`}
                                src={m.img}
                                alt="step"
                                activeId={active}
                                top={m.pos}
                                left={m.left}
                                UID={m.id}
                                key={m.id}
                                animatemarker={animationactive}
                                onClick={() => setActive(m.id)}
                            />
                            {active === m.id && <Details>
                                <Title>{m.title}</Title>
                                <Discription>{m?.description}
                                </Discription>
                            </Details>}
                        </>
                    )
                })}

            </Left>
        </Aboutbody>
    );
}

export default Index;
